function readApiError(res, fallback) {
  if (res?.logout) return "Session expired. Please sign in again.";
  return res?.data?.msg || res?.error || fallback;
}

async function clippingGet(hitAxios, path) {
  const res = await hitAxios({
    path,
    post: false,
    showLoading: false,
    showSnackbar: false,
  });
  if (res?.logout) throw new Error("Session expired. Please sign in again.");
  if (!res?.data?.success) throw new Error(readApiError(res, "Request failed."));
  return res.data.data;
}

export function fetchClippingProjects(hitAxios) {
  return clippingGet(hitAxios, "/api/clipping/projects");
}

export function fetchClippingProject(hitAxios, projectId) {
  return clippingGet(hitAxios, `/api/clipping/projects/${encodeURIComponent(projectId)}`);
}
